if ($('#profile-form').length > 0) {
    $(document).ready(function () {
        $('.phone-box').on('change', function () {
            if (this.value) {
                if (this.value == 6) {
                    $('.phone-format').removeAttr('placeholder');
                    $('.phone-format').attr('placeholder', '###############');
                    $('.phone-format').prop('maxlength', 15);
                }
                else {
                    $('.phone-format').removeAttr('placeholder');
                    $('.phone-format').attr('placeholder', '(###) ###-####');
                    $('.phone-format').prop('maxlength', 14);
                }
            }
        });

        $('.phone-box').trigger('change');
    });
    function setTab(tabId) {
        $('#contactInformation-tab').removeClass('active');
        $('#contactInformation-tab').removeClass('complete');
        $('#contactInformation-tab').addClass('disabled');
        $('#address-tab').removeClass('active');
        $('#address-tab').removeClass('complete');
        $('#address-tab').addClass('disabled');
        $('#phone-tab').removeClass('active');
        $('#phone-tab').removeClass('complete');
        $('#phone-tab').addClass('disabled');

        $('#contactInformation').addClass('fade').hide();
        $('#address').addClass('fade').hide();
        $('#phone').addClass('fade').hide();

        $('#btnPervious').addClass('d-none');
        $('#btnNext').addClass('d-none');
        $('#btnSave').addClass('d-none');
        $('html, body').animate({ scrollTop: 0 }, 'fast');
        if (tabId == 0) {
            $('#contactInformation-tab').addClass('active');
            $('#contactInformation-tab').addClass('complete');
            $('#contactInformation-tab').removeClass('disabled');
            $('#contactInformation-tab').prop('disabled', false);
            $('#contactInformation-tab').removeAttr('disabled');

            $('#btnNext').removeClass('d-none');

            $('#address').removeClass('active').removeClass('show');
            $('#phone').removeClass('active').removeClass('show');
            $('#contactInformation').removeClass('fade').show();
            $('#contactInformation-tab').tab('show');
        }
        if (tabId == 1) {
            $('#contactInformation-tab').addClass('complete');
            $('#contactInformation-tab').removeClass('disabled');
            $('#address-tab').addClass('active');
            $('#address-tab').addClass('complete');
            $('#address-tab').removeClass('disabled');
            $('#address-tab').prop('disabled', false);
            $('#address-tab').removeAttr('disabled');

            $('#btnPervious').removeClass('d-none');
            $('#btnNext').removeClass('d-none');

            $('#contactInformation').removeClass('active').removeClass('show');
            $('#phone').removeClass('active').removeClass('show');
            $('#address').removeClass('fade').show();
            $('#address-tab').tab('show');
        }
        if (tabId == 2) {
            $('#contactInformation-tab').addClass('complete');
            $('#contactInformation-tab').removeClass('disabled');
            $('#address-tab').addClass('complete');
            $('#address-tab').removeClass('disabled');
            $('#phone-tab').addClass('active');
            $('#phone-tab').addClass('complete');
            $('#phone-tab').removeClass('disabled');
            $('#phone-tab').prop('disabled', false);
            $('#phone-tab').removeAttr('disabled');

            $('#btnPervious').removeClass('d-none');
            $('#btnSave').removeClass('d-none');

            $('#contactInformation').removeClass('active').removeClass('show');
            $('#address').removeClass('active').removeClass('show');
            $('#phone').removeClass('fade').show();
            $('#phone-tab').tab('show');
        }
        $('.mobiledd div.content').html($('.mdc').html());
        $('.mobiledd span.content').html($('.mobiledd a.active:last').text());
        $('#tabid').val(tabId).trigger('change');
    }
    function showPerviousTab(e) {
            e.preventDefault();
            var tabId = parseInt($('#tabid').val());
            if (tabId > 0) {
                tabId = tabId - 1;
                setTab(tabId);
            }
            return true;
        }
    function showNextTab(e) {
            e.preventDefault();
            var tabId = parseInt($('#tabid').val());
            //validate
            if (tabId == 0) {
                $('#FirstName').required = false;
                $('#FirstName').attr('data-val', 'false').removeAttr('required').prop('required', false);
                $('span[data-valmsg-for="FirstName"]').text('');
                $('#LastName').required = false;
                $('#LastName').attr('data-val', 'false').removeAttr('required').prop('required', false);
                $('span[data-valmsg-for="LastName"]').text('');
                $('#Email').attr('data-val', 'false');
                $('span[data-valmsg-for="Email"]').text('');
                var fn = $.trim($('#FirstName').val());
                var ln = $.trim($('#LastName').val());
                var email = $.trim($('#Email').val());
                var valid = true;
                if (fn == '') {
                    $('#FirstName').required = true;
                    $('#FirstName').attr('data-val', 'true').prop('required', true);
                    $('span[data-valmsg-for="FirstName"]').text(window.app.label('RequiredField'));
                }
                if (ln == '') {
                    $('#LastName').required = true;
                    $('#LastName').attr('data-val', 'true').prop('required', true);
                    $('span[data-valmsg-for="LastName"]').text(window.app.label('RequiredField'));
                }
                if (email.length > 0) {
                    valid = email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|.('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                    if (!valid) {
                        $('#Email').attr('data-val', 'true');
                        $('span[data-valmsg-for="Email"]').text(window.app.label('InvalidEmail'));
                    }
                }
                if (fn == '' || ln == '' || !valid) return false;

                tabId = tabId + 1;
                setTab(tabId);
                $('#dvPostErr').hide();
                return true;
            }
            if (tabId == 1) {
                //remove divic address validation errors
                $('#CivicAddress_CivicNumber').required = false;
                $('#CivicAddress_CivicNumber').attr('data-val', 'false').removeAttr('required').prop('required', false);
                $('span[data-valmsg-for="CivicAddress.CivicNumber"]').text('');
                $('#CivicAddress_StreetName').required = false;
                $('#CivicAddress_StreetName').attr('data-val', 'false').removeAttr('required').prop('required', false);
                $('span[data-valmsg-for="CivicAddress.StreetName"]').text('');
                $('#CivicAddress_Municipality').required = false;
                $('#CivicAddress_Municipality').attr('data-val', 'false').removeAttr('required').prop('required', false);
                $('span[data-valmsg-for="CivicAddress.Municipality"]').text('');
                $('#CivicAddress_PostalCode').required = false;
                $('#CivicAddress_PostalCode').attr('data-val', 'false').removeAttr('required').prop('required', false);
                $('span[data-valmsg-for="CivicAddress.PostalCode"]').text('');
                var v2 = true;
                if ($('#CivicAddress_IsCivicMailingTheSame').is(':checked') == false) v2 = validateAddress('MailingAddress');
                else { //remove mailing address validation errors
                    $('#MailingAddress_CivicNumber').required = false;
                    $('#MailingAddress_CivicNumber').attr('data-val', 'false').removeAttr('required').prop('required', false);
                    $('span[data-valmsg-for="MailingAddress.CivicNumber"]').text('');
                    $('#MailingAddress_StreetName').required = false;
                    $('#MailingAddress_StreetName').attr('data-val', 'false').removeAttr('required').prop('required', false);
                    $('span[data-valmsg-for="MailingAddress.StreetName"]').text('');
                    $('#MailingAddress_Municipality').required = false;
                    $('#MailingAddress_Municipality').attr('data-val', 'false').removeAttr('required').prop('required', false);
                    $('span[data-valmsg-for="MailingAddress.Municipality"]').text('');
                    $('#MailingAddress_PostalCode').required = false;
                    $('#MailingAddress_PostalCode').attr('data-val', 'false').removeAttr('required').prop('required', false);
                    $('span[data-valmsg-for="MailingAddress.PostalCode"]').text('');
                }
                var v1 = validateAddress('CivicAddress');
                if (!(v1 && v2)) return false;
         
                var adrCivic = {
                    Id = $('#CivicAddress_Id').val(),
                    CivicNumber: $('#CivicAddress_CivicNumber').val(),
                    Country: 'CA',
                    IsCivicMailingTheSame: $('#CivicAddress_IsCivicMailingTheSame').is(':checked'),
                    Municipality: $('#CivicAddress_Municipality').val(),
                    PostalCode: $('#CivicAddress_PostalCode').val(),
                    Province: $('#CivicAddress_Province').val(),
                    StreetDirection: $('#CivicAddress_StreetDirection').val(),
                    StreetName: $('#CivicAddress_StreetName').val(),
                    TypeCd: 2,
                    UniteNumber: $('#CivicAddress_UnitNumber').val(),
                };
                adrMailing = {
                    Id = $('#MailingAddress_Id').val(),
                    CivicNumber: $('#MailingAddress_CivicNumber').val(),
                    Country: 'CA',
                    Municipality: $('#MailingAddress_Municipality').val(),
                    PostalCode: $('#MailingAddress_PostalCode').val(),
                    Province: $('#MailingAddress_Province').val(),
                    StreetDirection: $('#MailingAddress_StreetDirection').val(),
                    StreetName: $('#MailingAddress_StreetName').val(),
                    TypeCd: 1,
                    UniteNumber: $('#MailingAddress_UnitNumber').val(),
                };

                return validateAddressAjax(adrCivic, window.data.CivicHash, adrMailing, window.data.MailingHash);
            }
        }
    function validateAddress(addressType) {
        var pc = $('#' + addressType + '_PostalCode');
        var city = $('#' + addressType + '_Municipality');
        var street = $('#' + addressType + '_StreetName');
        var cn = $('#' + addressType + '_CivicNumber');
        if (addressType == 'CivicAddress') {
            if (pc.val() == '' && cn.val() == '' && (city.val() == '' || city.val() == null) && (street.val() == '' || street.val() == null)) return true;
        }
        if ($.trim(cn.val()) == '') {
            cn.required = true;
            cn.attr('data-val', 'true').prop('required', true);
            $('span[data-valmsg-for="' + addressType + '.CivicNumber"]').text(window.app.label('RequiredField'));
            cn.focus();
        }
        else {
            cn.required = false;
            cn.attr('data-val', 'false').removeAttr('required').prop('required', false);
            $('span[data-valmsg-for="' + addressType + '.CivicNumber"]').text('');
        }

        if (street.val()) {
            street.required = false;
            street.attr('data-val', 'false').removeAttr('required').prop('required', false);
            $('span[data-valmsg-for="' + addressType + '.StreetName"]').text('');
        }
        else {
            street.required = true;
            street.attr('data-val', 'true').prop('required', true);
            $('span[data-valmsg-for="' + addressType + '.StreetName"]').text(window.app.label('RequiredField'));
            street.focus();
        }

        if (city.val()) {
            city.required = false;
            city.attr('data-val', 'false').removeAttr('required').prop('required', false);
            $('span[data-valmsg-for="' + addressType + '.Municipality"]').text('');
        }
        else {
            city.required = true;
            city.attr('data-val', 'true').prop('required', true);
            $('span[data-valmsg-for="' + addressType + '.Municipality"]').text(window.app.label('RequiredField'));
            city.focus();
        }

        if ($.trim(pc.val()) == '') {
            pc.required = true;
            pc.attr('data-val', 'true').prop('required', true);
            $('span[data-valmsg-for="' + addressType + '.PostalCode"]').text(window.app.label('RequiredField'));
            pc.focus();
        }
        else {
            pc.required = false;
            pc.attr('data-val', 'false').removeAttr('required').prop('required', false);
            $('span[data-valmsg-for="' + addressType + '.PostalCode"]').text('');
        }

        if (pc.val() == '' || city.val() == '' || street.val() == '' || cn.val() == '' || city.val() == null || street.val() == null) return false;
        return true;
    }

    function validateAddressAjax(adr, adrHash, adrMailing, adrMailingHash) {
        $('#validationError').html('');
        $('#dvValidationError').hide();

        if (adr.CivicNumber == '' && (adr.StreetName == '' || adr.StreetName == null) && (adr.Municipality == '' || adr.Municipality == null) && adr.PostalCode == '' && adrMailing.CivicNumber == '' && (adrMailing.StreetName == '' || adrMailing.StreetName == null) && (adrMailing.Municipality == '' || adrMailing.Municipality == null) && adrMailing.PostalCode == '') {
            tabId = 2;
            setTab(tabId);
            return true;
        }
        var token = $('input[name="__RequestVerificationToken"]').val();
        $('#dvPostErr').hide();
        var isSame = $('#CivicAddress_IsCivicMailingTheSame').is(':checked');
        var url = window.app.hrefPrefix() + '/' + window.app.currentLanguage() + '/ChildAddress/ValidateAddressAjax/';
        $.ajax({
            type: "POST",
            url: url,
            data: { __RequestVerificationToken: token, civicAdr: adr, civicAdrHash: adrHash, mailingAdr: adrMailing, mailingAdrHash: adrMailingHash, isSame: isSame },
            dataType: "JSON",
            success: function (data) {
                if (data.errList) {
                    if (data.errList['Err']) {
                        $('#validationError').html(data.errList['Err']);
                        $('#dvValidationError').show();
                        $("html, body").animate({ scrollTop: 20 }, "slow");
                        return false;
                    }
                    else {
                        if (data.matchedCivicAddress || data.matchedMailingAddress) {
                            $('#dvCivicPanel').hide()
                            $('#dvMailingPanel').hide();
                            if (data.matchedCivicAddress) {
                                var m = data.matchedCivicAddress;
                                var s = formatAddress(m.CivicNum, m.UnitNumber, m.StreetFullName, m.StreetDir, m.Place, adr.Province, m.PostalCode);
                                $('#lblMatchedAddress').text(s);
                                var lbl = adr.TypeCd + '|' + m.StreetFullName + '|' + m.StreetDir + '|' + m.PostalCode + '|' + m.CivicNum + '|' + m.UnitNumber;
                                $('#lblMatchedAddressValue').text(lbl);
                                $('#dvCivicPanel').show();
                            }
                            if (data.matchedMailingAddress) {
                                var m = data.matchedMailingAddress;
                                var s = formatAddress(m.CivicNum, m.UnitNumber, m.StreetFullName, m.StreetDir, m.Place, adrMailing.Province, m.PostalCode);
                                $('#lblMatchedMailingAddress').text(s);
                                var lbl = adr.TypeCd + '|' + m.StreetFullName + '|' + m.StreetDir + '|' + m.PostalCode + '|' + m.CivicNum + '|' + m.UnitNumber;
                                $('#lblMatchedMailingAddressValue').text(lbl);
                                $('#dvMailingPanel').show();
                            }
                            var a = adr; /* window.data.CivicAddress; if (adr.Id == 0) a = adr;*/
                            var s = formatAddress(a.CivicNumber, a.UnitNumber, a.StreetName, a.StreetDirection, a.Municipality, a.Province, a.PostalCode);
                            $('#lblCurrentCivicAddressDesc').text(s);
                            /*a = window.data.MailingAddress; if (adrMailing.Id == 0)*/
                            a = adrMailing;
                            if (a) {
                                s = formatAddress(a.CivicNumber, a.UnitNumber, a.StreetName, a.StreetDirection, a.Municipality, a.Province, a.PostalCode);
                                $('#lblCurrentMailingAddressDesc').text(s);
                                $("input[type=radio][name=rdMailing]").prop('checked', true);
                            }
                            $("input[type=radio][name=rdCivic]").prop('checked', true);
                            $('#matchedAddressModal').modal('show');
                            return false;
                        }
                        else {
                            tabId = 2;
                            setTab(tabId);
                            return true;
                        }
                    }
                }
            },
            error: function (xhr, strStatus, strError) {
                console.log(strError);
                return true;
            },
            fail: function (err) {
                console.log(err);
                return true;
            }
        });
    }

    function updateAddress() {
        var rdcivic = $("input[type=radio][name=rdCivic]:checked");
        var rdMailing = $("input[type=radio][name=rdMailing]:checked");
        if (rdcivic.val() == 2) {
            var lbl = $('#lblMatchedAddressValue').text();
            setAddressValues('CivicAddress', lbl);
        } else {
            $('#PrepareCivicAddress').val(false);
        }
        if (rdMailing.length > 0) {
            if (rdMailing.val() == 2) {
                var lbl = $('#lblMatchedMailingAddressValue').text();
                setAddressValues('MailingAddress', lbl);
            } else {
                $('#PrepareMailingAddress').val(false);
            }
        }
        //$('#lblMatchedAddress').text('');
        //$('#lblMatchedMailingAddress').text('');
        //$('#lblMatchedAddressValue').text('');
        //$('#lblMatchedMailingAddressValue').text('');
        $('#validationError').html('');
        $('#dvValidationError').hide();
        tabId = 2;
        setTab(tabId);
    }

    function setAddressValues(addressType, lbl) {
        if (lbl) {
            var arr = lbl.split('|');
            var newTxt = arr[1];
            var $newOption = $("<option selected='selected'></option>").val(newTxt).text(newTxt);
            $('#' + addressType + '_StreetName').append($newOption).trigger('change');
            $('#' + addressType + '_StreetDirection').val(arr[2]);
            $('#' + addressType + '_PostalCode').val(arr[3]);
            $('#' + addressType + '_CivicNumber').val(arr[4]);
            $('#' + addressType + '_UnitNumber').val(arr[5]);
            $('#' + addressType + '_Validated').val(true);
        }
    }

    function formatAddress(civic, unit, stname, stdir, city, prv, postal) {
        if (!prv) prv = 'NB';
        var s = '';
        if (unit) s = unit + '-';
        s = s + civic + ' ' + stname;
        if (stdir) s = s + ' ' + stdir
        s = s + ', ' + city + ', ' + prv + ' ' + postal;
        return s;
    }
}